import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 3a5 5 0 0 1 5 5v8a5 5 0 0 1 -5 5h-12a5 5 0 0 1 -5 -5v-8a5 5 0 0 1 5 -5zm-9 6v6a1 1 0 0 0 1.514 .857l5 -3a1 1 0 0 0 0 -1.714l-5 -3a1 1 0 0 0 -1.514 .857z","key":"svg-0"}]]

const IconBrandYoutubeFilled = createReactComponent('filled', 'brand-youtube-filled', 'BrandYoutubeFilled', __iconNode);

export default IconBrandYoutubeFilled;